import React from 'react'
import Modal from '../../components/modal/modal'
import Button from '../../components/button/button'

const AddClassModal = ({ onSubmit, onClose }) => {
  return (
    <Modal>
      <div style={{marginBottom:'50px',textAlign:'center',fontSize:'20px',fontWeight:'bold'}}>是否加入当前课程？</div>
      <div style={{ display:'flex',justifyContent:'space-around',textAlign: 'center' }}>
        <Button
          label={"随便看看"}
          onClick={onClose}
        />
        <Button
          theme={'submit'}
          label={"加入课程"}
          onClick={onSubmit}
        />
      </div>
    </Modal>
  )
}

export default AddClassModal
